import { logMessage } from './helpers';

export class Requester {
    constructor(authorizeToken, headers) {
        this.refresh_token = {};
        this.headers = headers || {};

        if (authorizeToken) {
            this.headers['Authorization'] = authorizeToken['access'] ? (authorizeToken['access'].startsWith('Bearer ') ? authorizeToken['access'] : `Bearer ${authorizeToken['access']}`) : '';
            this.refresh_token = authorizeToken['refresh'];
        }

        this._headers = this.headers;
    }

    get_access_token() {
        let url = "/api/auth/token/refresh/";
        let requestHeaders = new Headers();
        requestHeaders.append("Content-Type", "application/json");
        let raw = JSON.stringify({
            "refresh": this.refresh_token
        });
        let requestOptions = {
            method: 'POST',
            headers: requestHeaders,
            body: raw,
        };
        return fetch(url, requestOptions)
            .then(response => response.json())
            .then(result => {
                localStorage.setItem('access', result.access);
                return result;
            });
    }

    sendRequest(datafeedUrl, urlPath, params) {
        if (params !== undefined) {
            const paramKeys = Object.keys(params);
            if (paramKeys.length !== 0) {
                urlPath += '?';
            }
            urlPath += paramKeys.map((key) => {
                return `${encodeURIComponent(key)}=${encodeURIComponent(params[key].toString())}`;
            }).join('&');
        }
        logMessage('New request: ' + urlPath);

        const options = { credentials: 'same-origin' };
        if (this._headers !== undefined) {
            options.headers = this._headers;
        }

        return fetch(`${datafeedUrl}/${urlPath}`, options)
            .then((response) => {
                if (response.status === 401) {
                    return this.get_access_token()
                        .then(result => {
                            const access_token = "Bearer " + result.access;
                            this.headers['Authorization'] = access_token;
                            this._headers['Authorization'] = access_token;

                            // Re-send the request with new token
                            const newOptions = { ...options, headers: { ...this._headers } };
                            return fetch(`${datafeedUrl}/${urlPath}`, newOptions);
                        })
                        .then(response => response.text())
                        .then(responseText => JSON.parse(responseText))
                        .catch(error => {
                            console.error('Error refreshing token:', error);
                            throw error;
                        });
                }
                return response.text().then(responseText => JSON.parse(responseText));
            });
    }
}
